module.exports = __webpack_public_path__ + "static/media/medication.js.a0fb9534.map";